// src/actions/languageActions.ts
import { Dispatch } from 'redux';
import * as types from './actionsTypes';
import { IStateLanguage } from 'store/store.model';
import i18n from '../../i18n'; // Importer la configuration i18n

// Action pour définir la langue
export const changeLanguage = (language: IStateLanguage, dispatch: Dispatch) => {
  localStorage.setItem('app_lang', language.language);

  i18n.changeLanguage(language.language).then(() => {
    dispatch({
      type: types.SET_LANGUAGE,
      payload: {
        language: language.language
      }
    });

  }); // Change la langue de l'application
}